import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'

import { TextField } from '@components/atoms/text-field'
import { daysData, weeksData } from '@config/data'
import { Select } from '@components/atoms/select'
import { dateFormat, dateOfWeeks } from '@utils/date'
import { PhoneField } from '@components/atoms/phone-field'
import { Radio } from '@components/atoms/radio'

export const Personal = memo(({ state, errors, onChange }) => {
  const startDates = useMemo(() =>
    dateOfWeeks({ startWeek: state.startWeekOn })
      .reduce((acc, date) => [
        ...acc,
        { id: dateFormat(date, 'YYYY-MM-DD'), label: dateFormat(date) }
      ],
        [])
    , [state.startWeekOn])

  return (
    <>
      <div className="flex space-x-4">
        <TextField
          name="firstName"
          label="First Name"
          value={state.firstName}
          onChange={onChange}
          required
          error={errors?.firstName}
          autoFocus
        />
        <TextField
          name="lastName"
          label="Last Name"
          value={state.lastName}
          onChange={onChange}
          required
          error={errors?.lastName}
        />
      </div>
      <TextField
        name="email"
        label="Email"
        type="email"
        value={state.email}
        onChange={onChange}
        required
        error={errors?.email}
      />
      <div className="">
        <PhoneField
          name="phoneNumber"
          label="Phone Number"
          value={state.phoneNumber}
          onChange={onChange}
          required
          error={errors?.phoneNumber}
        />
      </div>
      {/* <TextField
        name="phoneNumber"
        label="Phone Number"
        value={state.phoneNumber}
        onChange={onChange}
        required
        error={errors?.phoneNumber}
      /> */}
      <TextField
        name="instagram"
        label="Instagram"
        value={state.instagram}
        onChange={onChange}
      />
      {/* <Select
        name="startWeekOn"
        label="Start Week On"
        value={state.startWeekOn}
        onChange={onChange}
        list={daysData}
        required
        error={false}
      /> */}
      <div className="space-y-2 mb-5">
        <div className="text-slate-500">Start Week On :</div>
        <div className="flex space-x-6">
          {daysData.map(x => (
            <Radio
              name="startWeekOn"
              label={x.label}
              id={x.id}
              value={x.id}
              onChange={onChange}
              checked={state.startWeekOn === x.id}
            />
          ))}
        </div>
      </div>
      <Select
        name="startDate"
        label="Start Date"
        value={state.startDate}
        onChange={onChange}
        list={startDates}
      />
      <Select
        name="weeks"
        label="Weeks"
        value={state.weeks}
        onChange={onChange}
        list={weeksData}
      />
    </>
  )
})

Personal.propTypes = {
  state: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func
}